import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Icon } from 'antd';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import MapMenu from './MapMenu';

@inject('dataStore')
@inject('commonStore')
@observer
class SidebarMenu extends React.Component {
  static propTypes = {
    commonStore: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  componentWillMount() {
  }

  render() {
    const { commonStore, history } = this.props;
    const onClick = ({ key }) => {
      commonStore.handleSidebarKeySelection(key);
      switch (key) {
        case 'interactive-map':
          var myDataset = new URLSearchParams(window.location.search).get("dataset");
          // SERGIO_AUTH_ORIG history.push('/interactive-map?dataset='+myDataset);
          // SERGIO_AUTH_NEW history.push('/?dataset='+myDataset);
          history.push('/?dataset='+myDataset);
          break;
        case 'submit-dataset':
          history.push('/submit-dataset');
          break;
        default:
          break;
      }
    };

    // SERGIO_AUTH_ORIG {commonStore.currentRoute !== '/interactive-map' ? (
    // SERGIO_AUTH_NEW {commonStore.currentRoute !== '/' ? (
    return (
      <nav id="menu" className={commonStore.isSidebarActive ? 'open' : ''}>
        {commonStore.currentRoute !== '/' ? (
          <div>
            <Menu
              className="sidebar-menu__interactivemap"
              selectedKeys={[`${commonStore.sidebarSelectedKey}`]}
              mode="inline"
              onClick={onClick}
            >
              <Menu.Item key="interactive-map">
                <Icon type="global" />
                <span>Interactive Hazard Map</span>
              </Menu.Item>
              <Menu.Item key="submit-dataset">
                <Icon type="plus-square" />
                <span>Submit New Dataset</span>
              </Menu.Item>
            </Menu>

            <Menu mode="inline" className="sidebar-menu__menuitems">
              <Menu.Item key="option-1">
                <Icon type="solution" />
                <span>User Manual</span>
              </Menu.Item>
              <Menu.Item key="option-2">
                <Icon type="file" />
                <span>Documentation</span>
              </Menu.Item>
              <Menu.SubMenu
                key="option-3"
                title={
                  <span>
                    <Icon type="mail" />
                    <span>INGV</span>
                  </span>
                }
              >
                <Menu.Item key="option-4">
                  <Icon type="copyright" />
                  <span>Who We Are</span>
                </Menu.Item>
                <Menu.Item key="option-5">
                  <Icon type="customer-service" />
                  <span>Contact Us</span>
                </Menu.Item>
              </Menu.SubMenu>
            </Menu>
          </div>
        ) : null}
        <MapMenu />
      </nav>
    );
  }
}

export default withRouter(SidebarMenu);



// WEBPACK FOOTER //
// ./src/components/SidebarMenu.js